import { InputFields } from '@datacamp/input-fields';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import selectLastSubmission from '../selectors/selectLastSubmission';
import { MultipleChoice } from './MultipleChoice';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const AnswerPanel = _ref => {
  let {
    checkExercise,
    exercise,
    exerciseId
  } = _ref;
  const lastSubmission = useSelector(state => selectLastSubmission(state, exerciseId));
  const {
    t
  } = useTranslation('translation', {
    keyPrefix: 'ExplorableExercise'
  });
  switch (exercise.question.flavor) {
    case 'Open':
      {
        var _ref2, _lastSubmission$submi, _exercise$progress;
        const lastAttempts = (_ref2 = (_lastSubmission$submi = lastSubmission === null || lastSubmission === void 0 ? void 0 : lastSubmission.submittedCode) !== null && _lastSubmission$submi !== void 0 ? _lastSubmission$submi : (_exercise$progress = exercise.progress) === null || _exercise$progress === void 0 ? void 0 : _exercise$progress.last_attempt) === null || _ref2 === void 0 ? void 0 : _ref2.split('\n');
        return ___EmotionJSX(InputFields, {
          checkExercise: checkExercise,
          items: exercise.question.openQuestions,
          lastAttempts: lastAttempts,
          submitLabel: t('AnswerPanel.submitButton')
        });
      }
    case 'MultipleChoice':
      return ___EmotionJSX(MultipleChoice, {
        customQuestion: exercise.question.question,
        exerciseId: exerciseId,
        possibleAnswers: exercise.question.possible_answers
      });
    default:
      throw new Error('Flavor not found');
  }
};